import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import RouteConfigHandler from "../../templates/route-config-handler";
import Config from "../../config";
import { isEmptyOrNullOrUndefined } from "../../utils";

import PricingPageIN from "./IN";
import NewPricingPageLK from "./LK";
import OldPricingPage from "../../../pages/Pricing";

const { CURRENT_PLATFORM, PLATFORMS } = Config;

const PricingPage = ({ routeId }) => {
  const { appConfig } = useSelector((state) => state.application);

  const pricingPageContent = useMemo(() => {
    if (CURRENT_PLATFORM === PLATFORMS.IN) {
      return <PricingPageIN />;
    }

    const configData = appConfig.appConfig;
    let newPricing_enabled = true;

    if (!isEmptyOrNullOrUndefined(configData)) {
      const config =
        configData.find((element) => element.id === "new_pricing") ?? {};
      newPricing_enabled = config.enabled ?? false;
    }

    if (newPricing_enabled) {
      return <NewPricingPageLK />;
    } else {
      return <OldPricingPage />;
    }
  }, [appConfig.appConfig]);

  return (
    <RouteConfigHandler id={routeId}>{pricingPageContent}</RouteConfigHandler>
  );
};

export default PricingPage;
